import React from "react"
import { Flex, Text, Heading } from "@chakra-ui/react"
import { Link } from "components/Link"
import { space } from "theme/themeConfig"

export type ListProps = {
  heading: string
  variant?: string
  variantText?: string
  variantTitle?: string
  items: {
    href: string
    label: string
    passHref?: boolean
    target?: string
    rel?: string
  }[]
}

export const List: React.FC<ListProps> = ({
  heading,
  items,
  variant = "textLink",
  variantText = "book0",
  variantTitle = "demi0",
}) => {
  if (items?.length) {
    return (
      <Flex direction="column" mb={1}>
        <Heading as="h6" size="xs" variant={variantTitle} pb="0.85rem">
          {heading}
        </Heading>
        {items.map(({ href, label, target = "_self", rel }) => (
          <Link
            key={href}
            href={href}
            target={target}
            rel={rel}
            data-testid={label}
            mb={space[-2]}
            variant={variant}
          >
            <Text as="span" variant={variantText}>
              {label}
            </Text>
          </Link>
        ))}
      </Flex>
    )
  }
  return null
}
